<template>
  <div class="home">
    <HeaderComponent screenName=""/>
    <ContractVehiclesBannerComponent
     imageSrc="contracts-banner.jpg"
     heading="Contact Us"
    />
    <div class="section-div" data-aos="fade-up">
      <div class="cards-container">
        <div 
          v-for="(card, index) in cards" 
          :key="index" 
          class="card"
        >
          <img :src="require(`@/assets/contact/${card.imageSrc}`)" alt="Avatar" class="avatar" />
          <h2>{{ card.name }}</h2>
          <p>{{card.description}}</p>
            <p><a href="mailto:{{ card.email }}" style="color: #0072b1;">{{ card.email }}</a></p>
          <a :href=card.linkedin target="_blank"><img :src="require('@/assets/contact/linkedin.png')" alt="LinkedIn" class="linkedin-icon" /></a>
        </div>
      </div>
    </div>
    <FooterComponent />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, Ref } from 'vue';

// Components
import HeaderComponent from '@/components/HeaderComponent.vue';
import ContractVehiclesBannerComponent from '@/components/contract vehicles/ContractVehiclesBannerComponent.vue';

import FooterComponent from '@/components/FooterComponent.vue';

export default defineComponent({
  components: {
    HeaderComponent,
    ContractVehiclesBannerComponent,
    FooterComponent
  },
  data() {
    return {
      cards: [
        { name: 'Joe Anderson',description:'Managing Partner', email: 'janderson@g-14c.com', imageSrc: 'JoeAnderson.png', linkedin: 'https://www.linkedin.com/in/joe-anderson-us/'},
        { name: 'William Earp',description:'General Manager', email: 'wearp@g-14c.com', imageSrc: 'WilliamEarp.png', linkedin: 'https://www.linkedin.com/in/william-earp-37235a107/'},
      ]
    };
  },
  setup() {
    return {
    };
  },
});
</script>
<style scoped>

.section-div{
  background-color: #f2f2f2;
  padding-left: 110px;
  padding-right: 110px;
  padding-top: 55px;
  padding-bottom: 5px;
}


.cards-container {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 2.5rem; 
}

.card {
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 20px;
  width: 300px; 
  /* height: 350px; */
  text-align: center;
  font-family: Roboto;
}
.avatar {
  width: 100px; 
  height: 100px;
  border-radius: 50%;
  object-fit: cover;
  margin-bottom: 20px;
}
.card a {
  color: inherit;
  text-decoration: none;
}

.card a:hover {
  text-decoration: underline;
}

.divider {
  width: 80%;
  height: 1px;
  background-color: #ccc;
  margin: 20px auto;
}

.linkedin-icon {
  width: 30px;
  height: 30px;
  margin-top: 10px;
}

.linkedin-icon:hover {
  filter: grayscale(1);
}

</style>